import Reveal from "./Reveal";
import { trade } from "../data/site";

// Import & Export — global trade in diamonds and CZ jewellery.
export default function TradeSection() {
  return (
    <section className="bg-white py-16 md:py-28">
      <div className="container-luxe grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <p className="eyebrow mb-5">{trade.heading}</p>
          <h2 className="section-title mb-8">
            Diamonds &amp; CZ,{" "}
            <span className="italic text-gold-dark">across the world</span>
          </h2>
          <p className="max-w-md font-sans text-base font-light leading-relaxed text-charcoal/70">
            {trade.text}
          </p>

          <div className="mt-10 grid grid-cols-2 gap-px overflow-hidden border border-gold/20 bg-gold/20 sm:grid-cols-4">
            {trade.markets.map((m) => (
              <div key={m.code} className="bg-white px-4 py-6 text-center">
                <p className="font-serif text-3xl font-light text-gold-dark">
                  {m.code}
                </p>
                <p className="mt-2 font-sans text-xs uppercase tracking-[0.15em] text-charcoal/55">
                  {m.name}
                </p>
              </div>
            ))}
          </div>

          <p className="mt-6 font-sans text-sm font-light text-charcoal/55">
            {trade.years}+ years of trusted import &amp; export.
          </p>
        </Reveal>

        <Reveal delay={150} className="relative">
          <div className="overflow-hidden">
            <img
              src="/assets/cd/prod-tennis-navy.jpg"
              alt="Culture Diamond — global reach"
              className="h-[360px] w-full object-cover sm:h-[460px] lg:h-[560px]"
            />
          </div>
          <div className="absolute -top-5 -left-5 hidden h-28 w-28 border border-gold/40 lg:block" />
        </Reveal>
      </div>
    </section>
  );
}
